<div class="results-container">    
    <div class="search-breadcrumb">
        <div
            (click)="clearSearch()" 
            [class]="locale === 'es-US' ? 'search-breadcrumb-item-spanish' : 'search-breadcrumb-item'">
            {{breadcrumbText}}
        </div>
        <div class="search-breadcrumb-arrow" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div *ngIf="locale !== 'es-US' && queryNameOrSpecialty !== '' && queryNameOrSpecialty !== null && showSpinner === false" class="search-breadcrumb-item-2">
            {{breadcrumbText2}} "{{queryNameOrSpecialty}}"
        </div>
        <div *ngIf="locale === 'es-US' && queryNameOrSpecialty !== '' && queryNameOrSpecialty !== null && showSpinner === false" class="search-breadcrumb-item-2">
            {{breadcrumbText2}}
            {{queryNameOrSpecialty.length > 12 ? ('"'+ queryNameOrSpecialty.substring(0, 12) + '...') : '"'+ queryNameOrSpecialty + '"'}}
        </div>
        <div *ngIf="queryNameOrSpecialty === '' || queryNameOrSpecialty === null || showSpinner === true" class="search-breadcrumb-item-2">
            {{breadcrumbText2}}
        </div> 
    </div>

    <div *ngIf="showSpinner === false" class="results-toolbar">
        <div class="location-info">
            <div (click)="onOpenDistanceFilterBottomSheet()" class="location-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
                    <path d="M8.96777 0L5.28893 9.09812L4.03928 5.09906L1.04967e-05 3.98612L8.96777 0Z" fill="#959595"/>
                </svg>
                <span style="padding-left: 4px; padding-right: 4px;">{{queryCityOrZip}} ({{getDistanceInMilesFromSliderValue(distanceSliderValue)}} {{mileLabel}})</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="3" viewBox="0 0 6 3" fill="none">
                    <path d="M6 0H0L3.17647 3L6 0Z" fill="#8B8B8B"/>
                </svg>
            </div>
        </div>
        <div class="toolbar-actions">
            <button mat-icon-button [matMenuTriggerFor]="sortMenu" class="sort-button">
                <app-sort-icon-svg></app-sort-icon-svg>
            </button>
            <div class="filter-display-toggle-web" [class.selected]="(providerSearchFilterToggle$ | async)" (click)="searchState.toggleProviderSearchFilter()">
                <app-filter-icon-svg></app-filter-icon-svg>
                <div *ngIf="appliedFilterCount > 0" class="filter-display-toggle-count-web">{{appliedFilterCount}}</div>
            </div>
        </div>
    </div>
    <!-- Sort Menu -->
    <mat-menu #sortMenu="matMenu" class="sort-menu-container">
        <div (click)="$event.stopPropagation()">
            <div class="menu-label-sort">
                {{sortByTitle}}
            </div>
            <div class="menu-radio-option">
                <input type="radio" 
                    id="sort-distance" 
                    name="providerSort" 
                    value="distance" 
                    [(ngModel)]="providerSortMethod" 
                    (change)="onApplySortMethod('distance')">
                <label for="sort-distance">{{distanceLabel}}</label>
            </div>
            <div class="menu-radio-option">
                <input type="radio" 
                        id="sort-availability" 
                        name="providerSort" 
                        value="availability" 
                        [(ngModel)]="providerSortMethod" 
                        (change)="onApplySortMethod('availability')">
                <label for="sort-availability">{{availabilityLabel}}</label>
            </div>
            <div class="menu-radio-option">
                <input type="radio" 
                        id="sort-name" 
                        name="providerSort" 
                        value="name" 
                        [(ngModel)]="providerSortMethod" 
                        (change)="onApplySortMethod('name')">
                <label for="sort-name">{{nameLabel}}</label>
            </div>
        </div>
    </mat-menu>

    <!-- Loading Spinner -->
    <div *ngIf="showSpinner" class="spinner-container">
        <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="!showSpinner">
        <div class="results-title">{{resultsText}} ({{allResults.length || 0}})</div>

        <div class="results-list" #resultsList (scroll)="onScroll($event)">
            <div *ngFor="let result of getInfiniteScrollResults()">
            <app-provider-search-results-card-mobile 
                [provider]="result"
                [isPlus]="isPlus"
                [currentLocation]="currentLocation"
                [queryCityOrZip]="queryCityOrZip">
            </app-provider-search-results-card-mobile>
            </div>
            <div *ngIf="isLoadingMore" class="loading-more" style="display: flex; align-items: center; justify-content: center;">
                <mat-spinner diameter="40"></mat-spinner>
            </div>
        </div>
    </div>
    <br>
</div>
